import {RouteDefinition} from '../../../routes';
import {LocationEditScreen} from './LocationEditScreen';

export const TimeSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/time',
        component: LocationEditScreen,
    },
];
